import { DataEntryPresenterModel } from './data-entry-presenter.model';
export class CounterUserEntryPresenterModel extends DataEntryPresenterModel {
  isIncludedInQueryResult?: boolean;
}
